import { Injectable, OnDestroy } from '@angular/core';
import { PagedRecords } from '@frk/eds-components';
import { LiteratureApiService } from '@literature/services/api-services/literature-api.service';
import { LiteratureDataService } from '@literature/services/literature-data.service';
import { LiteratureGlobalConfigService } from '@literature/services/literature-global-config.service';
import { AppStateService, LiteratureFlow } from '@services/app-state.service';
import { DebugService } from '@services/debug.service';
import { IUserProfile, IUserProfileInfo } from '@services/profile.interface';
import { OrderHistDetail, OrderHistoryList } from '@types';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class OrderHistoryListService implements OnDestroy {
  dateFormat: string;
  pagedData: PagedRecords<OrderHistDetail> = new PagedRecords<OrderHistDetail>(
    25
  );
  unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private appStateService: AppStateService,
    private literatureDataService: LiteratureDataService,
    private literatureConfig: LiteratureGlobalConfigService,
    private literatureApiService: LiteratureApiService,
    private debugService: DebugService
  ) {
    this.debugService
      .getExpandAllComponents$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((expandAll: boolean): void => {
        if (expandAll) {
          this.pagedData.expandAll();
        }
      });
  }

  getOrderHistoryList(
    profileInfo: IUserProfileInfo
  ): Observable<OrderHistoryList> {
    this.dateFormat = this.literatureConfig?.dateFormat;
    const profile = this.literatureDataService.literatureUserProfileMapper(
      profileInfo
    );
    if (this.appStateService.getUseAPIM(LiteratureFlow.ORDER_HISTORY_LIST)) {
      return this.literatureApiService.getOrderHistoryListAPIMFlow(
        this.getOrderHistoryListAPIMUrl(profile?.userSysNo),
        profile
      );
    } else {
      return this.literatureApiService.getOrderHistoryList(
        this.getUrl(profile?.businessKey),
        profile
      );
    }
  }

  updateNumberOfRows(numberOfRows: number) {
    this.pagedData.pageSize = numberOfRows;
  }

  getPageSize(): number {
    return this.pagedData.pageSize;
  }

  goToPage(n: number): void {
    if (this.pagedData) {
      this.pagedData.pageNumber = n;
    }
  }

  getNumberOfPages$(): Observable<number> {
    return this.pagedData.numberOfPages$;
  }

  getNumberOfPages(): number {
    return this.pagedData.numberOfPages;
  }

  getPageNumber$(): Observable<number> {
    return this.pagedData.pageNumber$;
  }

  getCurrentPage$(): Observable<OrderHistDetail[]> {
    return this.pagedData.currentPage$;
  }

  getUrl(expressNo: string): string {
    return this.appStateService.getLiteratureOrderHistoryListUrl();
  }

  getOrderHistoryListAPIMUrl(userSysNo: string): string {
    return (
      this.appStateService.getOrderHistoryAPIMUrl() + `/${userSysNo}/history`
    );
  }

  getProfileData$(): Observable<IUserProfile> {
    return this.literatureDataService.getProfileData$();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
